import { connect } from "react-redux";
import AboutVR from "../../components/project-pages/AboutVR";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(AboutVR);
